@if (modelList().annoucementCampaign; as annoucementCampaign) {
    <section class="relative">
        <ui-m030-c110-model-hero
            [text]="'Hyundai Modelle kaufen – ' + locationHeadline()"
            [image]="annoucementCampaign.image"
            [title]="annoucementCampaign.link.text"
            [envkv]="{
                model: annoucementCampaign.modelHeadline,
                envkv: annoucementCampaign.envkv,
                score: annoucementCampaign.co2Class ?? '',
            }"
            isDigital="false"
            isAvailable="false"
            isFirstView
        >
            <a
                class="flex w-full min-w-fit items-center justify-center self-end bg-white px-20 py-16 text-16 text-accent md:w-max"
                [href]="annoucementCampaign?.link?.url"
                extras
            >
                Mehr Erfahren
            </a>
        </ui-m030-c110-model-hero>

        <span class="leading-21 absolute -bottom-0 translate-y-full px-12 py-5 text-14 text-grey-400">
            {{ annoucementCampaign.imageCaption }}
        </span>
    </section>
    @if (annoucementCampaign.imageCaption) {
        <div class="lg:bg-grey-100">
            <p class="leading-21 inner-page-wrapper pt-12 text-14 text-grey-400">
                {{ annoucementCampaign.imageCaption }}
            </p>
        </div>
    }
}

<div class="lg:bg-grey-100">
    <div class="inner-page-wrapper flex flex-col gap-20 pb-40 pt-24 lg:gap-56 lg:pb-[80px]">
        <div>
            <h1 class="text-center text-24 leading-28 text-black lg:text-50 lg:leading-58">Unsere Hyundai Modelle</h1>

            @if (dealer(); as dealer) {
                <h2 class="text-center text-16 leading-27 text-black lg:text-22 lg:leading-28">
                    Bei {{ dealer.name }} in {{ dealer.city }}
                </h2>
            }
        </div>

        <ui-m040-c110-model-select
            [activeCategory]="activeCategory()"
            [categories]="categories()"
            [filteredModels]="filteredModels()"
            (categorySelected)="categorySelected($event)"
            isFirstView
        />
    </div>
</div>
